import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidePage from "../pages/guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guide/:slug",
    element: <GuidePage />,
  },
  {
    path: "/pandabuy-sheet-guide",
    element: <Navigate to="/guide/pandabuy-sheet-guide" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;